<template>
  <div class="salesman-settlement">
    <div class="top-info">
      <div class="text1">业务员结算</div>
    </div>
    <div class="header">
      <label>业务员</label>
      <el-input placeholder="请输入业务员" v-model="name" @keyup.enter.native="pageChange(1)"></el-input>
      <label>结算日期</label>
      <el-date-picker v-model="date" type="month" placeholder="选择日期" value-format="yyyy-MM"></el-date-picker>
      <el-button type="warning" @click="pageChange(1)">查询</el-button>
      <el-button type="warning" plain @click="daochu()">导出</el-button>
    </div>
    <div class="body">
      <el-tabs v-model="activeName" @tab-click="pageChange(1)">
        <el-tab-pane label="全部" name="0"></el-tab-pane>
        <el-tab-pane label="未发放" name="1"></el-tab-pane>
        <el-tab-pane label="已发放" name="5"></el-tab-pane>
      </el-tabs>
      <el-table :data="tableData" border class="omtable" style="width: 100%" tooltip-effect="dark">
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="userName" label="业务员" min-width="200px" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="balanceDate" label="结算日期" min-width="160px" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="payNum" label="期数" min-width="100px" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="policyIncomes" label="结算类型" width="100px" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ all.BALANCE_TYPE[scope.row.type] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="policyFeeSum" label="总保费" min-width="150px" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="policyNum" label="总保单数" min-width="100px" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="policyIncomes" label="应结费用" min-width="140px" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.policyIncomes }}</span>
            <activityTip v-if="scope.row.activityIncomes * 1" activityName="含无门槛活动奖励" :subsidyIncomes="scope.row.activityIncomes"></activityTip>
          </template>
        </el-table-column>
        <!-- <el-table-column label="结算费用" v-if="userInfo.mechanId=='1243069822374080512'||userInfo.mechanId=='1267659740693729280'"> -->
        <el-table-column label="结算费用" min-width="140px" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.incomeTax }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" min-width="100px" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.balanceStatus | balanceStatus }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="操作" width="150px" fixed="right">
          <template slot-scope="scope">
            <el-button-group>
              <el-button type="success" :disabled="scope.row.balanceStatus != 1" size="small" @click="openAgreeModal(scope.row)">发放</el-button>
              <el-button type="warning" size="small" @click="openDetail(scope.row)">详情</el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="page" background layout="total,prev, pager, next" @current-change="pageChange" :page-size="10" :total="listCount"> </el-pagination>
    </div>
  </div>
</template>
<script>
import activityTip from '@/components/activityTip';
import { ruleTool } from '@/api/mixins';
//当前实例组件
export default {
  mixins: [ruleTool],
  data: () => ({
    userInfo: {},
    all: {},
    mechanUserType: '',
    balanceStatus: '', //详情结算状态
    tableData: [], //结算列表
    listCount: 0,
    pageNum: '',
    name: '',
    date: '',
    activeName: '0',
    form: {}
  }),
  components: { activityTip },
  mounted() {
    this.$tools.getall(data => {
      this.all = data;
    });
    this.getList();
    this.userInfo = this.$tools.getLocal('userinfo');
  },
  methods: {
    openDetail(row) {
      sessionStorage.setItem('salesmanSettlementDetail' + row.id, JSON.stringify(row));
      this.$router.push('/finance/salesmanSettlementDetail?detailId=' + row.id);
    },
    openAgreeModal(item) {
      this.$confirm(`您确定要发放${item.balanceDate}期结算金额${item.realIncomes}给${item.userName}吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$notice.loading('加载中...');
        this.$http({
          url: '/master/content/userBalance/send',
          type: 'post',
          params: { balanceId: item.id }
        })
          .then(data => {
            this.$message.success('操作成功');
            this.getList();
          })
          .finally(() => {
            loading.close();
          });
      });
    },
    pageChange(page) {
      this.pageNum = page;
      this.getList();
    },
    getList() {
      const params = {
        pageNum: this.pageNum,
        pageSize: 10,
        balanceType: 2,
        asc: false,
        balanceStatus: this.activeName != '0' ? this.activeName : '',
        balanceDate: this.date,
        userName: this.name,
        orderBy: 'id'
      };
      this.$http({
        url: '/master/content/UserBalances/list',
        type: 'put',
        params: params
      }).then(data => {
        this.tableData = data.data;
        this.listCount = data.total;
      });
    },
    daochu() {
      const params = {
        balanceType: 2,
        balanceStatus: this.activeName != '0' ? this.activeName : '',
        balanceDate: this.date,
        mechanShowName: this.name
      };
      this.$tools.daochu('/master/content/exportUserBalanceList', params);
    }
  }
};
</script>
<style lang="scss">
@import './salesmanSettlement.scss';
</style>
